export type MunilyAreaPictureUploaderSize = 'small' | 'large';

export const MUNILY_AREA_PICTURE_UPLOADER_DEFAULTS = {
  size: 'small' as MunilyAreaPictureUploaderSize,
  alt: '',
  disabled: false,
} as const;
